module.exports = __webpack_public_path__ + "img/right-go.5f8d956a.svg";